document.querySelectorAll('.ctr-video-reviews__swiper').forEach((el) => {
  const slider = el.closest('.ctr-video-reviews__slider');
  new Swiper(el, {
    slidesPerView: 'auto',
    spaceBetween: 20,
    grabCursor: true,
    navigation: {
      prevEl: slider.querySelector('.ctr-video-reviews__nav-btn--prev'),
      nextEl: slider.querySelector('.ctr-video-reviews__nav-btn--next'),
    },
    breakpoints: {
      768: {
        spaceBetween: 24,
      },
    },
  });
});

document.querySelectorAll('.ctr-video-reviews__video-card').forEach((card) => {
  const video = card.querySelector('video.ctr-video-reviews__video-img');
  const btn = card.querySelector('.ctr-video-reviews__play');
  const pauseBtn = card.querySelector('.ctr-video-reviews__ctrl-pause');
  const muteBtn = card.querySelector('.ctr-video-reviews__ctrl-mute');
  const progressWrap = card.querySelector('.ctr-video-reviews__progress-wrap');
  const progressFill = card.querySelector('.ctr-video-reviews__progress-fill');

  if (!video || !btn) return;

  function play() {
    document.querySelectorAll('.ctr-video-reviews__video-card--playing').forEach((other) => {
      if (other === card) return;
      const otherVideo = other.querySelector('video.ctr-video-reviews__video-img');
      if (otherVideo) otherVideo.pause();
      other.classList.remove('ctr-video-reviews__video-card--playing');
    });
    video.play();
    card.classList.add('ctr-video-reviews__video-card--playing');
  }

  function pause() {
    video.pause();
    card.classList.remove('ctr-video-reviews__video-card--playing');
  }

  function updateMuteBtn() {
    if (!muteBtn) return;
    muteBtn.classList.toggle('is-muted', video.muted);
    muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
  }

  card.addEventListener('click', (e) => {
    if (e.target.closest('.ctr-video-reviews__play') || e.target.closest('.ctr-video-reviews__controls')) return;
    video.paused ? play() : pause();
  });

  btn.addEventListener('click', () => {
    video.paused ? play() : pause();
  });

  if (pauseBtn) {
    pauseBtn.addEventListener('click', () => {
      video.paused ? play() : pause();
    });
  }

  if (muteBtn) {
    muteBtn.addEventListener('click', () => {
      video.muted = !video.muted;
      updateMuteBtn();
    });
  }

  if (progressWrap && progressFill) {
    progressWrap.addEventListener('click', (e) => {
      if (!video.duration) return;
      const rect = progressWrap.getBoundingClientRect();
      const ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      video.currentTime = ratio * video.duration;
    });
  }

  video.addEventListener('timeupdate', () => {
    if (!progressFill || !video.duration) return;
    const pct = (video.currentTime / video.duration) * 100;
    progressFill.style.width = pct + '%';
    progressWrap && progressWrap.setAttribute('aria-valuenow', Math.round(pct));
  });

  video.addEventListener('pause', () => {
    card.classList.remove('ctr-video-reviews__video-card--playing');
  });

  video.addEventListener('ended', () => {
    card.classList.remove('ctr-video-reviews__video-card--playing');
    if (progressFill) progressFill.style.width = '0%';
  });
});
